import { useEffect } from "react";
import { useNavigate } from "react-router";
import { UserRole } from "~/api/model";
import { useGetProject } from "~/api/projects/projects";
import { useGetCurrentUser } from "~/api/users/users";
import { NotFound } from "~/components/NotFound";
import { PageLayout } from "~/components/PageLayout";
import { DocumentsList } from "~/features/case/components/list/DocumentsList";
import { ROUTES, useProjectParams } from "~/helpers";
import { useTrackPageVisit } from "~/hooks/useTrackPageVisit";

export const CasePage = () => {
  useTrackPageVisit("app/case/visit");
  const { organizationId, caseId } = useProjectParams();
  const { isError: isProjectError } = useGetProject(organizationId, caseId);
  const navigate = useNavigate();
  const { data: userInfo } = useGetCurrentUser();

  useEffect(() => {
    if (userInfo?.role === UserRole.GUEST) {
      navigate(ROUTES.ACCESS_DENIED);
    }
  }, [userInfo, navigate]);

  if (isProjectError) {
    return <NotFound backRoute={ROUTES.CASES({ organizationId })} />;
  }

  return (
    <PageLayout>
      <DocumentsList />
    </PageLayout>
  );
};
